<template>
  <div class="top-content-container">
    <b-row>
      <b-col md="8">
        <b-breadcrumb v-if="title" class="company-breadcrumbs pb-2">
          <b-breadcrumb-item  class="breadcrumb-item-disabled">
            <span class="text-uppercase font-family-medium">
              {{ title }}
            </span>
          </b-breadcrumb-item>
        </b-breadcrumb>

        <b-breadcrumb v-if="parts" class="company-breadcrumbs">
          <b-breadcrumb-item>
            <span
              @click="navigate"
              class="text-uppercase font-family-medium"
            >
              {{ parts[0] }}
            </span>
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            <span class="text-uppercase font-family-medium">
              {{ parts[1] }}
            </span>
          </b-breadcrumb-item>
        </b-breadcrumb>

        <h1
          class="font-lg primary-dark font-family-medium position-relative content-title"
        >
          {{ title }}
        </h1>
      </b-col>

      <slot></slot>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ViewHeader",

  props: { 
    title: { type: String },
    parts: { type: Array },
    originRouteName: { type: String },
  },

  methods: {
    navigate() {
      this.$router.push({ name: this.originRouteName })
    }
  }
}
</script>

<style>

</style>